import MultipleSelectField from './MultipleSelectField.component';

export default MultipleSelectField;